import React from 'react'
import { useTranslation } from 'react-i18next';
import i18n from '../../../language/i18n';
import { normalizeLang } from '../../../utils/localeDataLoader';
import { useIntroduceMessageQuery } from 'hooks';

function IntroduceStatement() {
    useTranslation();
    const currentLang = normalizeLang(i18n.language);
    const { data: messageData } = useIntroduceMessageQuery(currentLang);

    if (!messageData) {
        return <div>Loading...</div>;
    }

    return (
        <div className='IntroduceStatement'>
            {messageData.description && <div className="quill-content" dangerouslySetInnerHTML={{ __html: messageData.description }} />}
        </div>
    )
}

export default IntroduceStatement
